import Swal from "sweetalert2";
import { getInstance } from "./baseapi";

const dataToken = localStorage.getItem("tokenBackoffice");
const instance = getInstance();

export const getJobPosition = async (queryparams) => {
    try{
        const headers = {
            Authorization: "Bearer " + dataToken,
          };
        const response = await instance.get(`/api/mgr/job-position`, {
            headers:headers,
            params: {...queryparams}
        })
        if (response.status === 200) {
            return response;
        } else {
            return null;
        }
    }catch(error) {
        Swal.fire({
            icon: "error",
            title: error.response.data.message,
            confirmButtonText: "OK",
        }).then((result) => {});
    }
};

export const getJobPositionByID = async (id) => {
    try {
        const headers = {
            Authorization: "Bearer " + dataToken,
        };
        const response = await instance.get(`/api/mgr/job-position/${id}`, {
            headers: headers,
        });
        if (response.status === 200) {
            return await response;
        } else {
            return null;
        }
    } catch (error) {
        Swal.fire({
            icon: "error",
            title: error.response.data.message,
            confirmButtonText: "OK",
        }).then((result) => {});
    }
};

export const createJobPosition = async (body) => {
    try {
      const headers = {
        Authorization: "Bearer " + dataToken,
      };
      const response = await instance.post(`/api/mgr/job-position`, body, {
        headers: headers,
      });
  
      if (response.status === 200) {
        return response;
      } else {
        return null;
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: error.response.data.message,
        confirmButtonText: "OK",
      }).then((result) => {});
    }
};

export const updateJobPositionByID = async (id, body) => {
    try {
        const headers = {
            Authorization: "Bearer " + dataToken,
        };
        const response = await instance.put(`/api/mgr/job-position/${id}`, body, {
            headers: headers,
        });
    
        if (response.status === 200) {
            return response;
        } else {
            return null;
        }
    } catch (error) {
        Swal.fire({
            icon: "error",
            title: error.response.data.message,
            confirmButtonText: "OK",
        }).then((result) => {});
    }
};

export const deleteJobPosition = async (id) => {
    try {
      const headers = {
        Authorization: "Bearer " + dataToken,
      };
      const response = await instance.delete(`/api/mgr/job-position/${id}`, {
        headers: headers,
      });
  
      if (response.status === 200) {
        return await response;
      } else {
        return null;
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: error.response.data.message,
        confirmButtonText: "OK",
      }).then((result) => {});
    }
};